// extracted by mini-css-extract-plugin
module.exports = {"col_L":"col_L-3B8mIUCz"};